import axiosIns from "@/libs/axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchTemplates(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/templates", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchTemplate(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/templates/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    editTemplate(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/templates", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteTemplate(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/templates", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  }
};
